// extracted by mini-css-extract-plugin
export default {"deleteAccountPage":"DeleteAccountPage_deleteAccountPage__CWTd1","logo":"DeleteAccountPage_logo__QmSOJ","deleteAccountPageForm":"DeleteAccountPage_deleteAccountPageForm__+lpAF"};